/**
 * Adjusts the given date and time by a specified number of milliseconds.
 *
 * @param dateTime - The date and time to adjust.
 * @param adjustmentMs - The number of milliseconds to adjust the time by.
 * @returns A new Date object with the adjusted time.
 */
function adjustTime(dateTime: Date, adjustmentMs: number): Date {
  return new Date(dateTime.getTime() + adjustmentMs);
}

export { adjustTime };
